import React from 'react'
import { Box } from '@mui/material'
import { Link } from 'react-router-dom'
import OpsotTypography from '../../ui/OpsotTypography/index'
import {
	FooterContainer,
	TopSection,
	RightSection,
	NavItems,
	SocialMediaIcons,
	LowerFooter
} from './components'
import {
	copyRightFooterText,
	menuItems,
	socialMediaLinks
} from './utils/footerData'
import { OpsotLogoInverse } from '../assets'
import { useGlobalStore } from '../../../services/store/store'
import { focusStyle } from '../../../styles/common'

const OpsotFooter = () => {
	const isAdmin = useGlobalStore((state) => state.isAdmin)
	return (
		<FooterContainer
			sx={{
				'& a': {
					...focusStyle
				}
			}}
			component="footer"
		>
			<TopSection>
				<Box
					sx={{
						marginRight: '5rem'
					}}
				>
					<a
						href="https://www.college.police.uk"
						target="_blank"
						rel="noreferrer"
					>
						<OpsotLogoInverse width="150" height="auto" />
					</a>
				</Box>

				<RightSection>
					<NavItems>
						{isAdmin && (
							<Link key="draft-toolkits" to="/draft-toolkits" underline="none">
								<OpsotTypography
									content="Draft toolkits"
									variant="bodySmallWhite"
								/>
							</Link>
						)}
						{menuItems.map((item) => (
							<Link key={item.label} to={item.path} underline="none">
								<OpsotTypography
									content={item.label}
									variant="bodySmallWhite"
								/>
							</Link>
						))}
						{/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
						<Link
							key="feedback"
							to="#"
							underline="none"
							onClick={() =>
								window.open('https://www.college.police.uk/contact', '_blank')
							}
						>
							<OpsotTypography content="Feedback" variant="bodySmallWhite" />
						</Link>
					</NavItems>

					<SocialMediaIcons>
						{socialMediaLinks.map((icon) => (
							<a
								key={icon.alt}
								href={icon.path}
								target="_blank"
								rel="noreferrer"
							>
								<Box
									component="img"
									src={icon.src}
									alt={icon.alt}
									sx={{ width: 24, height: 'auto' }}
								/>
							</a>
						))}
					</SocialMediaIcons>
				</RightSection>
			</TopSection>

			<LowerFooter>
				<OpsotTypography
					variant="copyrightFooterText"
					content={copyRightFooterText}
				/>
			</LowerFooter>
		</FooterContainer>
	)
}

export default OpsotFooter
